import _ from 'lodash';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
const CONFIG_API_ENABLED = config.servers.config.enabled;
const CONFIG_API_URL = config.servers.config.url;
export interface ServiceDto {
  products: ProductDto[];
  commons: ProductDto[];
}
export interface ProductResource {
  en: string;
  ko: string;
}
export interface ProductDto {
  product?: string;
  displayKey: string; // 공통UI (구버전)지원을 위해 필요한 필드
  webUrl: string;
  context: string;
  enabled: boolean;
  target?: '_blank' | '_self';
  icon: string;
  title: ProductResource;
  description: ProductResource;
}
interface ProductApi {
  products(): Promise<ServiceDto>;
}
class ProductApi implements ProductApi {
  async products(): Promise<ServiceDto> {
    const resp = await axios.get(`${CONFIG_API_URL}/services`);
    return resp.data;
  }
}
const productApi = new ProductApi();
export default productApi;
